/**
 * Creates random order number
 * @returns {string} the randomly generated order uuid number
 */
export const createUuid = (): string => {
  return (Math.random() * 10 ** 10).toString(16).replace('.', '');
};
